<template>
  <div id="app">
    <div class="wrapper">
      <!-- Content -->
      <div id="content" class="content">
        <div class="row justify-content-center align-items-center login-top">
          <div class="col-lg-3 p-0 d-none d-lg-block">
            <div class="log-pic">
              <img src="../../assets/images/login.jpg" alt />
            </div>
          </div>
          <div class="col-lg-3 p-lg-0">
            <div class="login">
              <img class="log-logo" src="../../assets/images/logo.png" alt />
              <div class="log-text">
                Preencha as informações para realizar login no Pesquisa.
              </div>
              <form @submit.prevent="login">
                <div class="alert alert-info" v-if="!auth">
                  Usuários usem seu usuário/matricula e senha
                  do AD
                </div>

                <div class="" v-if="auth">
                  Bem-vindo <b>{{ authData.givenname }}</b>
                </div>

                <a
                  v-if="!auth"
                  :href="
                    'https://idp.modern.humanflow.com.br/simplesaml/custom.php?redirect_url=' +
                    $store.state.frontUrl +
                    'login'
                  "
                  class="btn btn-block btn-login"
                  >Login com AD
                </a>
                <router-link
                  v-if="!auth"
                  :to="'/login-email'"
                  class="btn btn-block btn-login"
                  >Login com Email
                </router-link>
                <button v-if="auth" class="btn btn-block btn-login">
                  Continuar para o Pesquisa
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer id="footer" class="footer">
      <div class="copyright">
        <p class="left small">InnovareTI 2019</p>
        <p class="right small">
          Desenvolvido por
          <a href="https://www.innovareti.com.br/" target="_blank">
            <img src="../../assets/images/logo-innovare-dark.png" alt="Logo" />
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      auth: false,
      authData: {},
    };
  },
  mounted() {
    if (this.$route.query.param != "" && this.$route.query.param != undefined) {
      this.auth = true;

      let data = atob(this.$route.query.param);
      data = JSON.parse(data);
      this.authData = {};
      for (let prop in data.attributes) {
        this.authData[
          prop
            .replace(
              "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/",
              ""
            )
            .replace(
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/",
              ""
            )
        ] = data.attributes[prop][0];
      }

      this.authData.logoutUrl = data.logoutUrl;
    }
  },
  methods: {
    login() {
      const self = this;
      const api = this.$store.state.api + "adfsAuth";

      axios
        .post(api, {
          register: self.authData.windowsaccountname,
        })
        .then((response) => {
          self.$store.commit("auth", {
            token: response.data.access_token,
            type_id: response.data.type_id,
            trial: response.data.trial,
          });

          if (response.data.type_id == 1) {
            if (response.data.researchFirstStep) {
              self.$router.push(response.data.researchFirstStep);
            } else {
              self.$router.push({ path: "/" });
            }
          } else if (response.data.type_id == 2) {
            self.$router.push({ path: "/worker" });
          } else if (response.data.type_id == 3) {
            self.$router.push({ path: "/worker" });
          } else if (response.data.type_id == 4) {
            self.$router.push({ path: "/requestAccess" });
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Roboto", sans-serif;
}
form .form-input {
  width: 90% !important;
  font-size: 15px !important;
  padding: 10px !important;
  border: 1px solid #c0c0c0;
}
form .form-label {
  width: 90% !important;
  display: block;
  text-align: left;
  font-size: 16px !important;
  margin-left: auto;
  margin-right: auto;
}
form .form-button {
  width: 90%;
  padding: 10px;
  font-size: 18px;
  border-radius: 30px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #f0f0f0;
  background: #1197d6 !important;
  color: white;
}

#myModal {
  text-align: left;
}

@media (max-width: 768px) {
  .ibox {
    margin: 0px 0px 0px 0px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Auth/Login.vue